import React from 'react';
import { Route, Routes } from 'react-router-dom';
import ListPaymentAccount from './pages/ListPaymentAccount';

const PaymentAccount = () => {
  return (
    <Routes>
      <Route path="/" element={<ListPaymentAccount />} />
    </Routes>
  );
};

export default PaymentAccount;
